
import {initWebComponent} from "@/helpers/web-component-helper";
import {getAllBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {setVisibleByLayerName} from "@/helpers/ol/ol-layer-helper";
import {getActiveFilter, getFilterLayerName, setFilterGeometry} from "@/helpers/filter/filter-helper";
import {checkApplyButton, updateFilterBadge} from "@/helpers/filter/filter-settings-helper";
import {stopDraw} from "@/helpers/ol/draw/ol-draw-polygon-helper";
import sw from "datatables.net-plugins/i18n/sw.mjs";

export class OlDrawGeometryTypeComponent extends HTMLElement {
    constructor(){
        super();

        const activeFilter = getActiveFilter()
        const sendBboxWithFilter = activeFilter.Filter.filter.SendBboxWithFilter

        let noSelectionActive = 'active'
        let noSelectionChecked = 'checked="checked"'
        let sendBboxWithFilterActive = ''
        let sendBboxWithFilterChecked = ''
        if(sendBboxWithFilter) {
            noSelectionActive = ''
            noSelectionChecked = ''
            sendBboxWithFilterChecked = 'checked="checked"'
            sendBboxWithFilterActive = 'active'
            updateFilterBadge(this, 'Zichtbaar gebied')

            setTimeout(() => {
                setFilterGeometry()
            })
        } else {
            updateFilterBadge(this)
        }

        const template = document.createElement('template');
        template.innerHTML = `
                <div class="btn-group btn-group-toggle bg-light p-1 w-100" data-toggle="buttons">
                    <label data-value="" class="btn-filter-geometry btn btn-default btn-sm md-btn-flat waves-effect ` + noSelectionActive + `">
                        <input type="radio" name="rdiOlDrawGeometryType" value="" ` + noSelectionChecked + `>
                        Geen selectie
                    </label>
                    <label data-value="Valt geheel in" class="btn-filter-geometry btn btn-default btn-sm md-btn-flat waves-effect">
                        <input type="radio" name="rdiOlDrawGeometryType" value="WITHIN">
                        Valt geheel in
                    </label>
                    
                    <label data-value="Rakend aan" class="btn-filter-geometry btn btn-default btn-sm md-btn-flat waves-effect">
                        <input type="radio" name="rdiOlDrawGeometryType" value="INTERSECTS">
                        Rakend aan
                    </label>
                    <label data-value="Zichtbaar gebied" class="btn-filter-geometry btn btn-default btn-sm md-btn-flat waves-effect ` + sendBboxWithFilterActive + `">
                        <input type="radio" name="rdiOlDrawGeometryType" value="BBOX" ` + sendBboxWithFilterChecked + `>
                        Zichtbaar gebied
                    </label>
                </div>
`;
        initWebComponent(this, template)

        this.addEventListener('click', (element) => {

            const target = element.target
             if(target.tagName === 'LABEL') {
                 updateFilterBadge(this, target.dataset.value)
                 this.querySelectorAll('.btn-filter-geometry').forEach(element => {
                     element.classList.remove('active')
                 })
                 target.classList.add('active')
             } else {

                 getAllBySelector('ol-draw-geometry input').forEach(element => {
                     element.checked = false
                 })

                 switch (target.value) {
                     case '':
                     case 'BBOX':
                         stopDraw()
                         hideElementsBySelector('ol-draw-geometry')
                         setVisibleByLayerName(getFilterLayerName(), false)

                         hideElementsBySelector('#divFilterToolsMeasureDrawButtons')
                         hideElementsBySelector('#divFilterToolsMeasureDrawButtonsMobile')
                         break;
                     case 'WITHIN':
                         showElementsBySelector('ol-draw-geometry')
                         hideElementsBySelector('[data-language="LineString"]')
                         setVisibleByLayerName(getFilterLayerName(), true)
                         break;
                     case 'INTERSECTS':
                         showElementsBySelector('ol-draw-geometry')
                         setVisibleByLayerName(getFilterLayerName(), true)
                         break;
                 }
             }

            checkApplyButton()
        });
    }
}

